import React from 'react';
import { withRouter } from 'react-router-dom';
import Box from '@bit/knotchinc.web-react-components.box';
import { ErrorIconContainer, StyledErrorIcon, ErrorTitle, ErrorText, ErrorDescriptionContainer, StyledErrorButton, StyledErrorButtonText } from './styled.js';

const ErrorGeneral = ({ error, history }) => (
  <Box p="200px 0" width="100%" height="678px" m="0 auto">
    <ErrorIconContainer height="82px">
      <StyledErrorIcon type="error" />
    </ErrorIconContainer>
    <ErrorDescriptionContainer width="400px">
      <ErrorTitle uppercase dark>
        {error.title || 'Whoops! Something went wrong'}
      </ErrorTitle>
      <ErrorText>
        {error.message ||
          "Well, that's embarrassing! Looks like something went wrong on our end. Give the button below a press, or please reach out to your Knotch associate."}
      </ErrorText>
      <StyledErrorButton onClick={() => history.go(0)}>
        <StyledErrorButtonText>Try again</StyledErrorButtonText>
      </StyledErrorButton>
    </ErrorDescriptionContainer>
  </Box>
);

export default withRouter(ErrorGeneral);
